export const organizations = {
  background: {
    button: {
      country: '#f3f4f4',
      countryActive: '#66f0a0',
    },
  },
  color: {
    icon: {
      edit: '#66f0a0',
    },
    buttonAdd: '#66f0a0',
  },
}
